/** Shared helpers for supply-bundle placement/channel publisher + app labels. */

export interface PublisherAppRef {
  id?: string;
  appId?: string;
  name?: string;
  appName?: string;
  bundleId?: string | null;
}

/** Supports placement shape (id/name) and channel shape (publisherId/publisherName). */
export interface PublisherWithApps {
  id?: string;
  name?: string;
  publisherId?: string;
  publisherName?: string;
  apps?: PublisherAppRef[];
}

export function getPublisherNamesLabel(
  publishers?: PublisherWithApps[] | null,
  fallbackName?: string | null
): string {
  const names = (publishers ?? [])
    .map((publisher) => publisher?.publisherName?.trim() || publisher?.name?.trim())
    .filter(Boolean) as string[];
  if (names.length) {
    return names.join(', ');
  }
  return fallbackName?.trim() || '—';
}

/** Display label: name, else bundleId, else id. */
export function getAppDisplayLabel(app?: PublisherAppRef | null): string {
  if (!app) {
    return '';
  }
  return (
    app.appName?.trim() ||
    app.name?.trim() ||
    app.bundleId?.trim() ||
    app.appId?.trim() ||
    app.id?.trim() ||
    ''
  );
}

export function getPublisherAppsLabel(
  publishers?: PublisherWithApps[] | null,
  channelApps?: PublisherAppRef[] | null
): string {
  const names = new Set<string>();
  (publishers ?? []).forEach((publisher) => {
    (publisher.apps ?? []).forEach((app) => {
      const label = getAppDisplayLabel(app);
      if (label) {
        names.add(label);
      }
    });
  });
  (channelApps ?? []).forEach((app) => {
    const label = getAppDisplayLabel(app);
    if (label) {
      names.add(label);
    }
  });
  return names.size ? [...names].join(', ') : '—';
}
